<template>
<div id="stepper">    
    <label v-if="title !== undefined">{{ title }}</label>
    <hr>
    <div class="input-group justify-content-center">
        <div class="input-group-prepend">
            <button class="btn btn-primary rounded-circle" v-on:click.prevent="decrement"><i class="fas fa-minus"></i></button>
        </div>
        
        <input 
            type="number" 
            v-model="count"
            class="form-control border-0"
            style="flex: 1 1 auto;"
            aria-label=""
            disabled
        >
        
        <div class="input-group-append">
            <button class="btn btn-primary rounded-circle" type="button" v-on:click.prevent="increment"><i class="fas fa-plus"></i></button>
        </div>
    </div>
    <hr class="mb-3">
</div>
    
</template>


<script>
export default {
    name: 'Stepper',
    props: {
        value: {
            type: Number,
            default: 0
        },
        title: {
            type: String, 
            default: undefined
        },
        minValue: {
            type: Number,
            default: 0
        },
        maxValue: {
            type: Number,
            default: undefined
        }
    
    },
    computed: {
        count: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        increment: function() {
            if (this.maxValue !== undefined) {
                if (this.count + 1 <= this.maxValue) {
                    this.count++;
                }
            } else {
                this.count++;
            }
        },
        decrement: function() {
            if (this.minValue !== undefined) {
                if (this.count - 1 >= this.minValue) {
                    this.count--;
                }
            } else {
                this.count--;
            }
        }
    },
    created() {
        if (this.count < this.minValue) {
            this.count = this.minValue;
        }
    }
}
</script>


<style scoped lang="scss">
    $border-radius: 5px;

    input {
        text-align: center
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    input {
        // background-color: #bee3f8 !important;
        background-color: white !important;
        // margin-left: -15px;
        // margin-right: -15px;
        font-weight: 700;
        font-size: 14px
    }

    hr {
        margin: 0;
    }

    label {
        margin-top: 4px;
        margin-bottom: 4px
    }

    .btn {
        border-radius: $border-radius;
        // font-size: 20px;
        // font-weight: bold;
    }

    .round {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.42;
        border-radius: 15px;
        border: none;
    }


    i.fa-plus {
        // The porto template sometimes hides this icon. This forces the display of it
        display: inherit !important;
    }

    
</style>